<div class="common-heading" >
    {{title}}
</div>